import { demoEnabled } from './demoFlag';

/** The registration this build talks about. The demo must never query, display or
 *  link to Casey's actual airplane, so it uses a made-up tail. */
export const TRACKED_REG = demoEnabled() ? 'N123AB' : 'N8366X';

// Pull the most-recent ADS-B trace for the aircraft (from the /api/track-history
// proxy → adsb.lol) and downsample it to a compact path for storing on a flight.
// Called right after a flight is logged, while the trace still covers that flight.
export async function fetchFlightTrack(reg = TRACKED_REG): Promise<{ track: [number, number][]; maxAlt: number } | null> {
  try {
    const res = await fetch(`${import.meta.env.BASE_URL}api/track-history?reg=${encodeURIComponent(reg)}`);
    const data = await res.json();
    const pts: { lat: number; lon: number; alt: number | null }[] = Array.isArray(data.points) ? data.points : [];
    if (pts.length < 2) return null;
    // Cap at ~400 points so it stays tiny in Firestore.
    const step = Math.max(1, Math.floor(pts.length / 400));
    const track: [number, number][] = [];
    let maxAlt = 0;
    for (let i = 0; i < pts.length; i += step) {
      const p = pts[i];
      if (typeof p.lat !== 'number' || typeof p.lon !== 'number') continue;
      track.push([Math.round(p.lat * 1e5) / 1e5, Math.round(p.lon * 1e5) / 1e5]);
      if (typeof p.alt === 'number' && p.alt > maxAlt) maxAlt = p.alt;
    }
    // Always include the final point so the path ends where it landed.
    const last = pts[pts.length - 1];
    if (last && typeof last.lat === 'number') track.push([Math.round(last.lat * 1e5) / 1e5, Math.round(last.lon * 1e5) / 1e5]);
    return track.length >= 2 ? { track, maxAlt } : null;
  } catch {
    return null;
  }
}
